module.exports = __webpack_public_path__ + "imgs/rchamp-mob.94f8feb4.webp";